import Checkbox from "@mui/material/Checkbox";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";

export function TaskCheckbox(props: {
    checked: boolean;
    disabled?: boolean;

    // dense trims the hit area down to what fits inside a calendar item
    dense?: boolean;

    // tint is what the empty circle wears, for the callers that draw the box on a
    // coloured ground. A neutral grey reads as dirt against a tint, so those callers
    // hand in something that belongs to the same colour family.
    tint?: string;
    onChange: (checked: boolean) => void;
}) {
    return (
        <Checkbox
            checked={props.checked}
            disabled={props.disabled}
            size={props.dense ? "small" : "medium"}
            onChange={e => props.onChange(e.target.checked)}
            icon={<CheckCircleOutline />}
            checkedIcon={<CheckCircle />}
            sx={{
                // green says "done", so nothing but a ticked box wears it. A touch
                // leaves hover behind on a phone, which would otherwise strand an
                // empty circle in the colour of a full one.
                color: props.tint || "grey.400",
                "&.Mui-checked": { color: "success.main" },
                ...(props.dense && {
                    p: 0.25,
                    "& .MuiSvgIcon-root": { fontSize: 15 },
                }),
            }}
        />
    );
}
